import { Text, Image, Heading, Box, LayoutGrid } from '@asktia/tia-ui'
import { FC } from 'react'
import WelcomeIllustration from '../../assets/welcome-illustration.png'
import { ActionPage } from './components/ActionPage'
import { useNavigation } from 'src/hooks/useNavigation'
import { useEffect } from 'react'
import { useAmpli, useScrollToTopOnPageLoad } from 'src/hooks'
import { SmallCheckmarkIcon } from 'src/components/Blocks/Icons'

export const MemberBenefits = ({ children }: { children: string }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                textAlign: 'left',
                mt: 4
            }}
        >
            <Box
                sx={{
                    minWidth: 5,
                    height: 5,
                    backgroundColor: 'secondaryBackground',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    borderRadius: 3
                }}
            >
                <SmallCheckmarkIcon color="text" />
            </Box>
            <Text sx={{ pl: 2, lineHeight: '20px' }}>{children}</Text>
        </Box>
    )
}
